import { useState } from 'react';

export default function ServicesSection() {
  const [activeService, setActiveService] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  
  const services = [
    {
      title: 'Grant Writing',
      content: 'Strategic, professionally written grant proposals to position your organization for competitive funding success.'
    },
    {
      title: 'Application Writing & Development',
      content: 'Clear, compelling content designed to showcase your mission, vision, and goals to maximize your chances of approval.'
    },
    {
      title: 'Custom Requests',
      content: 'Flexible solutions tailored to your unique project needs, scope, and goals.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50" aria-labelledby="services-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 id="services-heading" className="text-4xl font-light text-gray-900 mb-4">
            Our <span className="font-bold">Services</span>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div className="space-y-6" role="list" aria-label="ProEditions services">
            {services.map((service, index) => (
              <div key={index} className="border-b border-gray-200 pb-6" role="listitem">
                <button
                  onClick={() => setActiveService(activeService === index ? -1 : index)}
                  className="w-full text-left flex items-center justify-between cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1a4d2e] rounded-md p-2"
                  aria-expanded={activeService === index}
                  aria-controls={`service-content-${index}`}
                  aria-label={`${service.title} - ${activeService === index ? 'Collapse' : 'Expand'} details`}
                >
                  <h3 className="text-xl font-medium text-gray-900">
                    {service.title}
                  </h3>
                  <i 
                    className={`ri-${activeService === index ? 'subtract' : 'add'}-line text-gray-600`}
                    aria-hidden="true"
                  ></i>
                </button>
                
                {activeService === index && (
                  <div 
                    id={`service-content-${index}`}
                    className="mt-4"
                    role="region"
                    aria-label={`${service.title} details`}
                  >
                    <p className="text-gray-600 font-light leading-relaxed">
                      {service.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <div className="relative">
            {!imageLoaded && (
              <div className="w-full h-80 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 animate-pulse rounded-lg"></div>
            )}
            <img
              src="https://static.readdy.ai/image/afa85a1250ffb5ee259f890220a101e9/5a2674c4123dd5062532e9eda9a29b6a.png"
              alt="ProEditions team collaborating on business writing projects"
              className={`w-full h-80 object-cover object-top rounded-lg transition-opacity duration-500 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
              loading="lazy"
              onLoad={() => setImageLoaded(true)}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
